import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronLeft, ChevronRight, ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const HomeSlider = () => {
  const { t } = useTranslation();
  const [currentIndex, setCurrentIndex] = useState(0);

  const slideImages = [
    '/assets/images/ChatGPT Image Jun 1, 2026, 02_32_00 PM.png',
    '/assets/images/ChatGPT Image Jun 5, 2026, 05_31_38 PM.png',
    '/assets/images/ChatGPT Image Jun 5, 2026, 05_33_14 PM.png'
  ];

  const slides = t('slider.slides', { returnObjects: true });

  useEffect(() => {
    const timer = setInterval(() => {
      handleNext();
    }, 5000);
    return () => clearInterval(timer);
  }, [currentIndex]);

  const handleNext = () => {
    setCurrentIndex((prev) => (prev + 1) % slideImages.length);
  };

  const handlePrev = () => {
    setCurrentIndex((prev) => (prev - 1 + slideImages.length) % slideImages.length);
  };

  return (
    <div className="relative h-[600px] md:h-[80vh] w-full overflow-hidden bg-dark-green-deep">
      <AnimatePresence initial={false}>
        <motion.div
          key={currentIndex}
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 1 }}
          className="absolute inset-0"
        >
          <div className="absolute inset-0 bg-black/40 z-10"></div>
          <img
            src={slideImages[currentIndex]}
            alt={slides[currentIndex]?.title}
            className="w-full h-full object-cover"
          />
        </motion.div>
      </AnimatePresence>

      <div className="relative z-20 container mx-auto px-4 h-full flex flex-col justify-center">
        <motion.div
          key={`text-${currentIndex}`}
          initial={{ y: 20, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ delay: 0.5, duration: 0.8 }}
          className="max-w-2xl text-white"
        >
          <h2 className="text-4xl md:text-6xl font-bold mb-4">
            {slides[currentIndex]?.title}
          </h2>
          <p className="text-xl md:text-2xl text-gold-light mb-8">
            {slides[currentIndex]?.subtitle}
          </p>
          <div className="flex flex-wrap gap-4">
            <Link 
              to="/enquiry" 
              className="bg-gold-primary text-white px-8 py-4 rounded-xl font-bold hover:bg-gold-primary/90 transition-all shadow-xl flex items-center space-x-2"
            >
              <span>{t('slider.getStarted')}</span>
              <ArrowRight size={20} />
            </Link>
            <Link 
              to="/services" 
              className="bg-white/10 backdrop-blur-md border-2 border-white text-white px-8 py-4 rounded-xl font-bold hover:bg-white hover:text-dark-green transition-all shadow-md"
            >
              {t('slider.ourServices')}
            </Link>
          </div>
        </motion.div>
      </div>

      {/* Navigation Arrows */}
      <button
        onClick={handlePrev}
        className="absolute left-4 top-1/2 -translate-y-1/2 z-30 p-2 rounded-full bg-white/20 hover:bg-white/40 text-white transition-all hidden md:block"
      >
        <ChevronLeft size={32} />
      </button>
      <button
        onClick={handleNext}
        className="absolute right-4 top-1/2 -translate-y-1/2 z-30 p-2 rounded-full bg-white/20 hover:bg-white/40 text-white transition-all hidden md:block"
      >
        <ChevronRight size={32} />
      </button>

      {/* Indicators */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-30 flex space-x-2">
        {slideImages.map((_, index) => (
          <button
            key={index}
            onClick={() => setCurrentIndex(index)}
            className={`w-3 h-3 rounded-full transition-all ${
              currentIndex === index ? 'bg-gold-primary w-8' : 'bg-white/50'
            }`}
          />
        ))}
      </div>
    </div>
  );
};

export default HomeSlider;
